import { render, staticRenderFns } from "./ChatSettingsView.vue?vue&type=template&id=afe3dc0c&"
import script from "./ChatSettingsView.vue?vue&type=script&lang=js&"
export * from "./ChatSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports